import { inject, Injectable, OnDestroy } from '@angular/core';
import { catchError, EMPTY, Observable, Subject } from 'rxjs';
import { SessionService } from 'src/app/auth/session.service';
import { subjectsComplete } from 'src/app/common/app.helpers';
import { BlockedUsersService } from 'src/app/common/services/blocked-users.service';
import { UserInfo } from 'src/app/interfaces';
import { DefaultService, PaginatableListOfExtendedUsers } from 'src/app/swagger-api';

@Injectable({ providedIn: 'root' })
export class ChatBlockingService implements OnDestroy {
  private userBlocked$: Subject<UserInfo> = new Subject<UserInfo>();
  private userUnblocked$: Subject<UserInfo> = new Subject<UserInfo>();
  private userBlockedListChangedExternally$: Subject<void> = new Subject();

  private apiService = inject(DefaultService);
  private sessionService = inject(SessionService);
  private blockedUsers = inject(BlockedUsersService);

  public ngOnDestroy(): void {
    subjectsComplete([this.userBlocked$, this.userUnblocked$, this.userBlockedListChangedExternally$]);
  }

  public get userBlocked(): Observable<UserInfo> {
    return this.userBlocked$.asObservable();
  }

  public get userUnblocked(): Observable<UserInfo> {
    return this.userUnblocked$.asObservable();
  }

  public get userBlockedListChangedExternally(): Observable<void> {
    return this.userBlockedListChangedExternally$.asObservable();
  }

  public fetchBlockedUsers(offset?: number, limit?: number): Observable<PaginatableListOfExtendedUsers> {
    return this.apiService.restProfileBlockIndex(this.sessionService.userId, offset, limit);
  }

  public blockUser(user: UserInfo): void {
    this.apiService
      .restProfileBlockPost(user.userId)
      .pipe(catchError(() => EMPTY))
      .subscribe(() => {
        this.blockedUsers.addUserId(user.userId);
        this.userBlocked$.next(user);
      });
  }

  public unBlockUser(user: UserInfo): void {
    this.apiService
      .restProfileBlockDelete(user.userId)
      .pipe(catchError(() => EMPTY))
      .subscribe(() => {
        this.blockedUsers.removeUserId(user.userId);
        this.userUnblocked$.next(user);
      });
  }

  public onBlockedUserListChangedExternally(): void {
    this.userBlockedListChangedExternally$.next();
  }
}
